import React, { Component } from "react";
import { connect } from "react-redux";
import ChangeContractType from "../comm/ChangeContractType";
import TableAddressArchived from "../address/TableArchived";
import TableStationArchived from "../station/TableArchived";
import TableAdvancedArchived from "../advanced/TableArchived";
import TableIcregisterArchived from "../icregister/TableArchived";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contractType: props.contractTab.archivedType || "settled",
    };
  }

  componentWillUnmount() {}

  onChange = e => {
    this.setState({
      contractType: e.target.value,
    });
  };

  render() {
    const { contractType } = this.state;
    const renderTable = () => {
      if (contractType === "oregistapp") {
        return <TableAddressArchived {...this.props} />;
      } if (contractType === "settled") {
        return <TableStationArchived {...this.props} />;
      } if (contractType === "advanced") {
        return <TableAdvancedArchived {...this.props} />;
      } if (contractType === "icregister") {
        return <TableIcregisterArchived {...this.props} />;
      }
    };
    return (
      <div>
        <ChangeContractType
          onChange={this.onChange}
          defaultValue={contractType}
        />
        {renderTable()}
      </div>
    );
  }
}

export default connect(state => ({ contractTab: state.contract_tab }))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/index/ComArchived.js